import { Card, DropdownMenu, H2, IconButton, ListRow, Separator, Text } from '@betterment/samba-react';

export const ClientAgreementsCard: React.FC = () => {
  return (
    <Card>
      <Card.Header
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 'space.300',
          py: 'space.200',
        }}
      >
        <H2 variant="title200">Client agreement</H2>
      </Card.Header>
      <Separator
        css={{
          fullWidthWithInset: 'space.200',
        }}
      />
      <Card.Header>
        <ListRow css={{ pt: 'space.200' }}>
          <ListRow.LeadingContent>
            <Text>Agreement name</Text>
            <Text color="text.weak" variant="text50">
              Uploaded - date
            </Text>
          </ListRow.LeadingContent>
          <ListRow.TrailingAsset>
            <DropdownMenu>
              <DropdownMenu.Trigger asChild={true}>
                <IconButton label="Show options" name="Ellipses" data-testid="dropdown-client-agreement-card-menu" />
              </DropdownMenu.Trigger>
              <DropdownMenu.Content align="center" side="bottom">
                <DropdownMenu.Item onSelect={() => {}}>View</DropdownMenu.Item>
                <DropdownMenu.Item onSelect={() => {}}>Replace</DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu>
          </ListRow.TrailingAsset>
        </ListRow>
      </Card.Header>
    </Card>
  );
};
